import { graphql } from '~/lib/graphql'

export const GetViewerFavoriteAndSubscribeNotification = graphql(`
  query getViewerFavoriteAndSubscribeNotification($restaurantId: RestaurantId!) {
    restaurant(restaurantId: $restaurantId) {
      viewerFavorited
      viewerInventoryNotificationSubscribed
    }
    viewer {
      __typename
    }
  }
`)
